"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstallationPanel = getInstallationPanel;

var _preact = require("preact");

var _InputGroupWithSubdomain = _interopRequireDefault(require("../../../ui-components/InputGroupWithSubdomain"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _PanelItems = require("../PanelItems");

var InstallationPanelBody = function InstallationPanelBody(_ref) {
  var isInstalled = _ref.isInstalled,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      onApiKeyChangeCallback = _ref.onApiKeyChangeCallback,
      onApiKeyClickCallback = _ref.onApiKeyClickCallback,
      onSubdomainChangeCallback = _ref.onSubdomainChangeCallback,
      onSubdomainClickCallback = _ref.onSubdomainClickCallback,
      apiKey = _ref.apiKey,
      subdomain = _ref.subdomain,
      _onClickManage = _ref.onClickManage,
      _onClickUninstall = _ref.onClickUninstall,
      errorFields = _ref.errorFields,
      isSavingCredentials = _ref.isSavingCredentials;
  return (0, _preact.h)("div", {
    className: "panel-body-container installation__panel_body"
  }, (0, _preact.h)("div", {
    className: "panel-body-title"
  }, "To install Thought Industries, you\u2019ll need"), (0, _preact.h)("div", {
    className: "panel-body-description"
  }, (0, _preact.h)("ul", {
    className: "panel-body-description-unordered-list"
  }, (0, _preact.h)("li", null, (0, _preact.h)("span", {
    className: "text--bold panel-body-description-label"
  }, "Admin permissions:"), (0, _preact.h)("span", {
    className: "panel-body-description-label-meta"
  }, ' ', "Admin permissions required to generate API key from Thought Industries dashboard.")))), (0, _preact.h)("div", {
    className: "panel-form-input"
  }, (0, _preact.h)(_InputGroupWithSubdomain.default, {
    key: "baseURL",
    title: "Base URL",
    required: true,
    meta: "This is your registered domain name at thoughtindustries.com.",
    error: (0, _PanelItems.getErrorMessage)('subdomain', errorFields),
    qaClasses: "qa-thought-industries-subdomain",
    value: subdomain,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onSubdomainChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onSubdomainClickCallback();
    },
    subdomain: ".thoughtindustries.com"
  })), (0, _preact.h)("div", {
    className: "panel-form-input"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    key: "apiKey",
    title: "API key",
    meta: "You can generate an API key from Security page in Thought Industries settings.",
    error: (0, _PanelItems.getErrorMessage)('apiKey', errorFields),
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-thought-industries-api-key",
    value: apiKey,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onApiKeyChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onApiKeyClickCallback();
    }
  })), isInstalled ? (0, _preact.h)(_PanelItems.ManageInstallationButtons, {
    onClickManage: function onClickManage() {
      return _onClickManage();
    },
    onClickUninstall: function onClickUninstall() {
      return _onClickUninstall();
    }
  }) : (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    },
    primaryButtonVariantType: "brand",
    primaryButtonText: "Install",
    isLoading: isSavingCredentials
  }));
};

function getInstallationPanel(props) {
  var isInstalled = props.isInstalled,
      _onSave2 = props.onSave,
      _onCancel2 = props.onCancel,
      _onApiKeyChangeCallback = props.onApiKeyChangeCallback,
      _onApiKeyClickCallback = props.onApiKeyClickCallback,
      _onSubdomainChangeCallback = props.onSubdomainChangeCallback,
      _onSubdomainClickCallback = props.onSubdomainClickCallback,
      errorMessage = props.errorMessage,
      apiKey = props.apiKey,
      subdomain = props.subdomain,
      _onClickManage2 = props.onClickManage,
      _onClickUninstall2 = props.onClickUninstall,
      errorFields = props.errorFields,
      hasUnsavedChanges = props.hasUnsavedChanges,
      isSavingCredentials = props.isSavingCredentials;
  return {
    body: (0, _preact.h)(InstallationPanelBody, {
      isInstalled: isInstalled,
      onSave: function onSave() {
        return _onSave2();
      },
      onCancel: function onCancel() {
        return _onCancel2();
      },
      onApiKeyChangeCallback: function onApiKeyChangeCallback(apiKey) {
        return _onApiKeyChangeCallback(apiKey);
      },
      onApiKeyClickCallback: function onApiKeyClickCallback() {
        return _onApiKeyClickCallback();
      },
      onSubdomainChangeCallback: function onSubdomainChangeCallback(subdomain) {
        return _onSubdomainChangeCallback(subdomain);
      },
      onSubdomainClickCallback: function onSubdomainClickCallback() {
        return _onSubdomainClickCallback();
      },
      onClickManage: function onClickManage() {
        return _onClickManage2();
      },
      onClickUninstall: function onClickUninstall() {
        return _onClickUninstall2();
      },
      apiKey: apiKey,
      subdomain: subdomain,
      errorMessage: errorMessage,
      errorFields: errorFields,
      isSavingCredentials: isSavingCredentials
    }),
    customClass: 'panel__body_without_header',
    hasUnsavedChanges: hasUnsavedChanges
  };
}